export default __webpack_public_path__ + "static/media/StudyMate.5f11fec9.png";